import { IItem } from '@checkout/items';
import { IOrder } from '@checkout/payments';
import { RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Summary } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './OrderHistoryItem.scss';

interface IOwnState {
  expanded: boolean;
}

interface IOwnProps {
  order: IOrder;
}

interface IConnectedProps { }

interface IConnectetDispatchProps { }

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class OrderHistoryItem extends React.Component<Props, {}> {

  state: IOwnState = {
    expanded: false,
  };

  onClick = () => {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { order, intl } = this.props;
    const { formatMessage } = intl;

    const itemClassNames = cx({
      [Styles.item]: true,
      [Styles.expanded]: this.state.expanded,
    });

    return (
      <div className={itemClassNames}>
        <div onClick={this.onClick} className={Styles.header}>
          <time className={Styles.date} dateTime={order.date}>{order.date}</time>
          <span className={Styles.order}>#{order.order}</span>
          <span className={Styles.showMore} />
        </div>
        <div className={Styles.body}>
          {!this.state.expanded && (
            <Fragment>
              <span className={Styles.description}>
                {order.items.map((item: IItem) => item.product && item.product.name).join(', ')}
              </span>
              <small className={Styles.status}>{order.statusDescription}</small>
              <span className={Styles.price}>{order.totals.grandTotalPrice}</span>
            </Fragment>
          )}
          {this.state.expanded && (
            <div className={Styles.summary}>
              <div className={Styles.notes}>
                <small>{formatMessage(messages.membership_order_status)}</small>
                <div className={Styles.statusDescription}>{order.statusDescription}</div>
                <small>{formatMessage(messages.membership_order_delivery)}</small>
                <div className={Styles.details}>
                  <p>{order.shippingAddress.firstName} {order.shippingAddress.lastName}</p>
                  {order.shippingAddress.company && (
                    <p>{order.shippingAddress.company}</p>
                  )}
                  <p>{order.shippingAddress.address1}{order.shippingAddress.address2 && `, ${order.shippingAddress.address2}`}</p>
                  {order.shippingAddress.state ?
                    <p>{order.shippingAddress.zipCode} {order.shippingAddress.city} {order.shippingAddress.state}, {order.shippingAddress.countryName}</p>
                    : <p>{order.shippingAddress.zipCode} {order.shippingAddress.city}, {order.shippingAddress.countryName}</p>
                  }
                </div>
              </div>
              <Summary totals={order.totals} items={order.items} title={formatMessage(messages.membership_order_summary_title)} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {}
  )
)(OrderHistoryItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/OrderHistoryItem/OrderHistoryItem.tsx